<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsTicketTracker from '@/@core/components/feedback/AnalyticsTicketTracker.vue'
import CustomerCommunicationDrawer from '@/views/feedback/customer-communication/Drawer.vue'
import CustomerCommunicationLogDrawer from '@/views/feedback/customer-communication/LogDrawer.vue'
import FeedbackResponseDrawer from '@/views/feedback/feedback-panel/drawer/FeedbackResponseDrawer.vue'
import TicketTable from '@/views/feedback/ticket-management/TicketTable.vue'
import TicketDrawer from '@/views/feedback/ticket-management/drawer/TicketDrawerV2.vue'

definePage({
  meta: {
    name: 'capa-management',
    subject: 'feedback.menu',
    action: 'capa_management',
  },  
})

const selectedFilters = ref({})
const { data: filterOptions } = await useApi(createUrl('/feedbacks/capa-filters'))

const ticketId = ref(null)
const capaId = ref(null)
const isTicketDrawerVisible = ref(false)
const isFeedbackResponseDrawerVisible = ref(false)
const feedbackResponseDrawerData = ref()
const refTicketTable = ref()
const communicationDrawerData = ref()
const communicationDrawerType = ref('View')

const showTicket = data => {
  ticketId.value = data.id
  capaId.value = data.capa_id ?? null
  isTicketDrawerVisible.value = true
}

const route = useRoute()

const showFeedbackResponse = (feedbackData, highlightedFeedbackResponse=null) => {
  feedbackResponseDrawerData.value = feedbackData
  feedbackResponseDrawerData.value.highlighted_feedback_response = highlightedFeedbackResponse
  isFeedbackResponseDrawerVisible.value = true
}

const isCommunicationDrawerVisible = ref(false)

const showCommunicationDrawer= (feedbackData, type, communicationFor='') => {
  communicationDrawerData.value = feedbackData
  communicationDrawerData.value.communicationFor = communicationFor
  isCommunicationDrawerVisible.value = true
}

const isCommunicationLogDrawerVisible = ref(false)

const showCommunicationLogDrawer = (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationLogDrawerVisible.value = true
}

const refTicketTracker =ref(null)

const refreshTicketData = async () => {
  refTicketTable.value?.fetchTickets()
  refTicketTracker.value?.fetchStatusGraph()
}

onMounted(() => {
  // check if ticket id is present in the route
  if (route.query.ticket && route.query.capa) {
    showTicket({
      id: route.query.ticket,
      capa_id: route.query.capa,
    })
  }
})
</script>

<template>
  <section>
    <VRow class="match-height">
      <VCol
        cols="12"
        md="6"
      >
        <FilterComponent
          v-model:filters="selectedFilters"
          :filters-options="filterOptions"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>
      <VCol
        cols="12"
        md="6"
      >
        <AnalyticsTicketTracker
          ref="refTicketTracker"
          :ticket-filters="selectedFilters"
          page="capa-management"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>

      <VCol cols="12">
        <TicketTable
          ref="refTicketTable"
          :ticket-filters="selectedFilters"
          page="capa-management"
          @show-ticket="showTicket"
          @show-feedback-response="showFeedbackResponse"
          @show-communication-drawer="showCommunicationDrawer"
          @show-communication-log-drawer="showCommunicationLogDrawer"
        />
      </VCol>
    </VRow>
  
    <FeedbackResponseDrawer
      v-model:isDrawerOpen="isFeedbackResponseDrawerVisible"
      :feedback-data="feedbackResponseDrawerData"
      :highlighted-feedback-question="feedbackResponseDrawerData?.highlighted_feedback_question"
      @show-communication-drawer="showCommunicationDrawer"
    />

    <CustomerCommunicationDrawer
      v-model:isDrawerOpen="isCommunicationDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="capa_customer_communication"
    />

    <CustomerCommunicationLogDrawer
      v-model:isDrawerOpen="isCommunicationLogDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="capa_customer_communication"
    />
    
    <TicketDrawer
      v-model:isDrawerOpen="isTicketDrawerVisible"
      :ticket-id="ticketId"
      :capa-id="capaId"
      @refresh-ticket-data="refreshTicketData"
      @show-feedback-response="showFeedbackResponse"
      @show-communication-drawer="showCommunicationDrawer"
    />
  </section>
</template>
